(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pf-mobile-thumbnails"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pf-mobile-thumbnails')) {
  customElements.define('pf-mobile-thumbnails', class extends HTMLElement {
    connectedCallback() {
      this.carousel = this.parentElement.querySelector('carousel-root');
      if (!this.carousel) return;
      this.buttons = [...this.querySelectorAll('button')];
      this.clickHandler = event => {
        const button = event.target.closest('button[data-slide]');
        if (!button || !this.contains(button) || !this.hasAttribute('data-ready')) return;
        this.carousel.updateThenGoToActiveSlide(Number(button.dataset.slide), true);
      };
      this.addEventListener('click', this.clickHandler);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.carousel, {subtree:true, childList:true, attributes:true, attributeFilter:['data-active']});
      this.sync();
    }
    sync() {
      const dots = [...this.carousel.querySelectorAll('.carousel--dot')];
      const index = dots.findIndex(dot => dot.dataset.active === 'true');
      if (index < 0 || typeof this.carousel.updateThenGoToActiveSlide !== 'function') return;
      this.setAttribute('data-ready', '');
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      if (this.index !== index) {
        this.index = index;
        const button = this.buttons[index];
        if (button) this.scrollTo({left:button.offsetLeft - this.offsetLeft - (this.clientWidth - button.offsetWidth)/2, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.clickHandler);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pf-price-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const prices = '.product-price--original, .product-price--compare, .product--price, .product--compare-price, .pfpg__price, .pf-rv__price, .pf-product-card__price';
  const excluded = 'section-store--cart-block, cart-root, cart-drawer, [id*="cart"], [class*="cart-drawer"], [class*="cart-page"], [class*="cart--"], pf-bundle-sticky';
  if (document.body.classList.contains('template--cart')) return;
  function format(node) {
    if (node.closest(excluded)) return;
    const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    const texts = [];
    while (walker.nextNode()) {
      const text = walker.currentNode;
      if (!text.parentElement.closest('.pf-display-price, script, style, .pfpg__from')) texts.push(text);
    }
    for (const text of texts) {
      const match = text.textContent.match(/^(\s*(?:[^\d\s]+\s*)?)(\d+(?:[.,\s\u00a0\u202f]\d{3})*)([.,])(\d{2})(\s*[^\d]*?)$/);
      if (!match) continue;
      const wrapper = document.createElement('span');
      wrapper.className = 'pf-display-price';
      const accessible = document.createElement('span');
      accessible.className = 'pf-display-price__accessible';
      accessible.textContent = text.textContent;
      const visual = document.createElement('span');
      visual.setAttribute('aria-hidden', 'true');
      const cents = document.createElement('sup');
      cents.className = 'pf-display-price__cents';
      cents.textContent = match[4];
      visual.append(match[1].replace(/€/g, '').trimStart() + match[2], cents, match[5].replace(/€/g, '').trimEnd());
      wrapper.append(accessible, visual);
      text.replaceWith(wrapper);
    }
  }
  function scan(root) {
    if (!(root instanceof Element)) return;
    if (root.closest('.pf-display-price')) return;
    if (root.matches(prices)) format(root);
    else { const price = root.closest(prices); if (price) format(price); }
    root.querySelectorAll(prices).forEach(format);
  }
  function start() {
    scan(document.body);
    new MutationObserver(records => {
      const roots = new Set();
      for (const record of records) {
        if (record.type === 'characterData') roots.add(record.target.parentElement);
        else {
          if (record.target instanceof Element && record.target.matches(prices)) roots.add(record.target);
          record.addedNodes.forEach(node => { if (node instanceof Element) roots.add(node); });
        }
      }
      roots.forEach(scan);
    }).observe(document.body, {childList:true, subtree:true, characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
